import * as Sentry from '@sentry/browser';
import { SITE_API } from '../settings';
export async function postEmailForDxConfirmation({
  email,
  firstName,
  token,
}: {
  /** results token */
  token: string;
  email: string;
  firstName: string;
}): Promise<unknown> {
  const url = `${SITE_API}/results/${token}/dx_confirmation/`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      email,
      first_name: firstName,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (res?.status === 201) {
    return res?.statusText || 'Dx confirmation submitted';
  }

  Sentry.setContext('profile', {
    email,
    firstName,
    token,
  });

  Sentry.captureException(res);

  throw new Error(res?.statusText);
}
